















import { computed, defineComponent } from "@vue/composition-api";
import { PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import usePaymentPackages from "@/hooks/usePaymentPackages";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { QuickTip } from "@/types";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle/PageTitle";
import QuickTipsItem from "@/components/QuickTipsItem";
import MoreMenuItemDefault from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemDefault";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "PageMenuPriceSettings",
  components: { QuickTipsItem, MoreMenuItemDefault, PageTitle, BasePage },
  setup() {
    const { authorities, isAdmin } = useAuthUser();
    const { paymentPackages, getPaymentPackages } = usePaymentPackages([PaymentPackageEnum.SUBSCRIPTION]);

    const checkedCallAuthorities = computed(() => checkAuthorities(authorities.value, ["updateMyCallPrice"]));
    const checkedMessageAuthorities = computed(() => checkAuthorities(authorities.value, ["updateMyMessagePrice"]));
    const checkedCallOptionsAuthorities = computed(() => checkAuthorities(authorities.value, ["updateMyCallOptions"]));
    const checkedSubscriptionLevelsAuthorities = computed(() =>
      checkAuthorities(authorities.value, ["updateMyContentSubscriptionLevel"])
    );
    const appointmentsEnabled = computed(() => config.featureAppointments && !isAdmin.value);

    const showPriceSettings = computed(
      () =>
        (config.featureCalling && checkedCallAuthorities.value) ||
        (config.featurePaidSentMessage && checkedMessageAuthorities.value) ||
        checkedCallOptionsAuthorities.value
    );
    const links = computed<IMoreMenuItem[]>(() => [
      ...(showPriceSettings.value
        ? [
            {
              label: $t("Messages and calls"),
              name: "priceSettings",
              to: {
                name: "priceSettings",
              },
            },
          ]
        : []),
      ...(checkedSubscriptionLevelsAuthorities.value && paymentPackages.value.length > 0 && !isAdmin.value
        ? [
            {
              label: $t("Subscription levels"),
              name: "profileSubscriptionLevels",
              to: {
                name: "profileSubscriptionLevels",
              },
            },
          ]
        : []),
    ]);

    const tipItem = computed<QuickTip>(() => ({
      icon: "sci-round-help-outline",
      color: "gray",
      text: $t("Looking for appointment prices? Go to {link}."),
      linkText: $t("Meetings options"),
      to: { name: "appointmentsSettings" },
    }));

    getPaymentPackages();

    return { links, tipItem, appointmentsEnabled };
  },
});
